import { useAuth } from "@/state/AuthProvider";
import { FOOTER_LINKS, SITE, SOCIAL } from "@/config/site";
import { Link } from "@/router/Router";
import { Icon, type IconName } from "@/components/ui/Icon";
import { Logo } from "@/components/ui/Logo";
import { Button } from "@/components/ui/Button";
import { ThemeToggle } from "@/components/ui/ThemeToggle";

/** The closing section of every page. */
export function Footer() {
  const { user } = useAuth();
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__hero">
          <p className="site-footer__statement">
            Liberating people
            <br />
            for <em>quality living.</em>
          </p>
          <div className="site-footer__cta">
            <Button to="/new" variant="primary" iconRight="arrowRight">
              Plan your visit
            </Button>
            <Button to="/give" variant="ghost" icon="heart">
              Give
            </Button>
          </div>
        </div>

        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <Link to={user ? "/welcome" : "/"} aria-label="Miracle Assembly — home">
              <Logo />
            </Link>
            <p className="site-footer__tag">{SITE.tagline}.</p>
            <address className="site-footer__address">
              147 Upper Owina Road, by Evbuotubu Police Station, Benin City
              <br />
              64 Boundary Road, off Airport Road, GRA, Benin City
            </address>
            <a href={`mailto:${SITE.email}`} className="site-footer__email">
              <Icon name="mail" size={16} /> {SITE.email}
            </a>
            <div className="social-row">
              {SOCIAL.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`Miracle Assembly on ${s.label}`} className="social-row__link">
                  <Icon name={s.icon as IconName} size={18} />
                </a>
              ))}
            </div>
          </div>
          {FOOTER_LINKS.map((col) => (
            <nav key={col.title} className="site-footer__col" aria-label={col.title}>
              <p className="site-footer__col-title">{col.title}</p>
              <ul>
                {col.links.map((l) => (
                  <li key={l.href + l.label}>
                    <Link to={l.href}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="site-footer__base">
          <p>© {year} Miracle Assembly. All rights reserved.</p>
          <p className="site-footer__pastor">Senior Pastor · {SITE.pastor}</p>
          <ThemeToggle withLabel />
          <a href="#top" className="site-footer__top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); }}>
            Back to top <Icon name="arrowRight" size={14} className="rot-270" />
          </a>
        </div>
      </div>
    </footer>
  );
}
